var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 1.4998) scale(1.000021)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6 6.08L12.35 0.08C12.24 0.03 12.12 0 11.99 0C11.87 0 11.75 0.03 11.64 0.08L0.39 6.08C0.27 6.15 0.17 6.24 0.1 6.36C0.03 6.48 0 6.61 0 6.74C0 6.88 0.03 7.01 0.1 7.13C0.17 7.25 0.27 7.34 0.39 7.41L2.99 8.8L2.99 13.33C2.99 13.7 3.13 14.06 3.38 14.33C4.6 15.7 7.36 17.99 11.99 17.99C13.53 18.01 15.06 17.73 16.49 17.17L16.49 20.24C16.49 20.44 16.57 20.63 16.71 20.78C16.86 20.92 17.05 20.99 17.24 20.99C17.44 20.99 17.63 20.92 17.78 20.78C17.92 20.63 17.99 20.44 17.99 20.24L17.99 16.45C18.97 15.88 19.86 15.17 20.61 14.33C20.86 14.06 21 13.7 20.99 13.33L20.99 8.8L23.6 7.41C23.72 7.34 23.82 7.25 23.89 7.13C23.96 7.01 23.99 6.88 23.99 6.74C23.99 6.61 23.96 6.48 23.89 6.36C23.82 6.24 23.72 6.15 23.6 6.08ZM11.99 16.49C7.94 16.49 5.55 14.51 4.49 13.33L4.49 9.59L11.64 13.41C11.75 13.46 11.87 13.49 11.99 13.49C12.12 13.49 12.24 13.46 12.35 13.41L16.49 11.2L16.49 15.54C15.31 16.09 13.82 16.49 11.99 16.49ZM19.49 13.33C19.05 13.83 18.54 14.28 17.99 14.67L17.99 10.39L19.49 9.59L19.49 13.33ZM17.62 8.9L17.6 8.88L12.35 6.08C12.17 5.99 11.97 5.98 11.78 6.04C11.6 6.09 11.44 6.22 11.35 6.4C11.25 6.57 11.23 6.77 11.29 6.96C11.34 7.15 11.47 7.31 11.64 7.41L16.03 9.74L11.99 11.89L2.34 6.74L11.99 1.6L21.65 6.74L17.62 8.9Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/studentIcon.8cb99f1edfb02150b44a126838119f0a.svg";
export { ForwardRef as ReactComponent };